(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7363],{

/***/ 68295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/vinted-shipping/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-02-22",
      tag: "Vinted",
      title: "The Ultimate Vinted Shipping Guide",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Vinted has a fairly straightforward approach to shipping. The seller provides shipping options based on the nature of the item, its size, and its weight. The buyer chooses their preferred method, and the seller must ship it using only this particular method within five business days. If any of these two conditions (buyer's preferred shipping method and timeframe) is not met, the order gets canceled, and the buyer receives a refund."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Buyers shoulder the cost of shipping as it appears on the total bill, along with the price of the item, upon check out."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What are the shipping options allowed on Vinted?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The platform offers three types of shipping methods:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Vinted-generated prepaid labels."
          }), " This is the easiest route for sending your package. Other online reselling marketplaces also offer this kind of option, so if you also sell on any of those, you're probably comfortable with this method already. Print out the prepaid USPS label provided by Vinted, attach it to your packaging box, and you're good to go. Insured packages are covered by a maximum of $100 if it gets lost or if the item incurs any damage while on transit. Vinted can assist sellers in filing for a claim with USPS but only for small packages (First Class). Otherwise, the claim should be coursed directly to the courier for bigger-sized packages (Priority Mail)."]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Custom shipping."
          }), " If you would like to offer your buyers shipping using another courier aside from USPS, make sure to enable \"custom shipping\" while preparing your listing for a particular item \u2013 especially for products with flammable contents or those that USPS cannot convey. Keep these two important things in mind:", /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Set an accurate shipping cost for your buyer."
              }), " Start by measuring and weighing the item, referring to your preferred courier's package sizes and pricing system. You wouldn't be able to adjust the shipping cost once the sale has been made."]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Go with a courier that offers tracking and insurance."
              }), " Vinted requires sellers to provide valid, active tracking numbers for visibility. Vinted will cancel the order if shipping isn't tracked. Also, you wouldn't want to be on the losing end if unfortunate circumstances such as loss of package or item damage happen."]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
            children: "Pick-up or no shipping."
          }), " This option works for massive or fragile items (e.g., from the Home or Kids categories) that are more practical for buyers to pick up themselves rather than convey through a courier."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How do I choose the right package size?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Items to be shipped using Vinted-generated prepaid labels must follow USPS's packaging and shipping guidelines. Be sure to choose the appropriate box for your item to avoid encountering any problems, like incurring extra charges, dealing with returns, and providing a negative experience to your buyer."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Below is a guide to give you an idea. It is, of course, best to check with your local USPS, especially if this is your first time to sell on Vinted."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "For items weighing 1.0 lb or less: Choose Small (First Class). This is ideal for accessories, clothing made of light materials, and small home furnishings."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "For items weighing 2.0 lbs or less: Choose Medium (Priority Mail). This is ideal for handbags, light pairs of shoes, trousers, dresses, jackets, and the like."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "For items weighing 5.0 lb or less: Choose Large (Priority Mail). This is ideal for chunky or heeled pairs of shoes, beddings, or even bundles of light clothing pieces."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "USPS has \"Flat Rate\" boxes, but note that this is incompatible with the Vinted-generated prepaid labels. Please don't use this option."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Whether you're using USPS or another courier (or the customer is picking the item up), take extra care in packaging your item. Doing this protects the item and reflects on your values as a seller. Use an outer packaging box in good condition. The actual item should be placed in a plastic bag or a small box. Ensure that the item is cushioned with foam, shredded paper, or other similar fillers to prevent damage during movement. Leave a short note to thank your buyer for purchasing as a final touch. You may even throw in a freebie to encourage repeat sales."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How do I track my packages?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Suppose you sent the item using the prepaid USPS label. In that case, the tracking information is easily visible to both the seller and the buyer through the \"Track package\" menu on your conversation screen. The information may not always be real-time, as it sometimes takes a few hours for the update to reflect on Vinted. Your other option is to enter the tracking number directly onto the USPS website."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "But if you sent it using custom shipping, don't forget to attach the proof of shipping or shipping receipt and update it to \"Item shipped\" within five days. Tracking information will not be visible to the buyer or Vinted, so you must take the responsibility to check it yourself on your chosen courier's platform and inform the buyer of any expected delays, if ever."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In summary, there are three shipping options offered on Vinted, depending on your item. Each one has its process and advantages. We hope this guide brought clarity and confidence to you in selling on Vinted!", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/vinted-shipping.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The Ultimate Vinted Shipping Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "The seller's cheat sheet on how to ship on Vinted. From who pays for shipping to the shipping options available to sellers and everything there is to know about successfully sending out purchased items to buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/vinted-shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/vinted-shipping"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The Ultimate Vinted Shipping Guide"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "The seller's cheat sheet on how to ship on Vinted. From who pays for shipping to the shipping options available to sellers and everything there is to know about successfully sending out purchased items to buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "February 22nd, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Vinted"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 96183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/vinted-shipping",
      function () {
        return __webpack_require__(68295);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(96183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);